<template>
  <div>
    <!------------------------------------------------->
    <!-- TABLE ---------------------------------------->
    <!------------------------------------------------->
    <v-layout wrap>
      <v-flex xs12 pt-4>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('afrus_engine.table.search')"
                  outlined
                  hide-details
                  @keydown="executeSearch"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table
            :headers="headers"
            :items="logs"
            :search="search"
            :options="pagination"
            :footer-props="{ 'items-per-page-options': [10, 15, 20] }"
            :items-per-page="pagination.itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
            @click:row="(item) => openDetails(item)"
            @update:options="pagination = $event"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>{{
                  $t("afrus_engine.table.header")
                }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
              </v-toolbar>
            </template>
            <template v-slot:[`item.gateway`]="{ item }">
              <div>{{ item.gateway }}</div>
            </template>
            <template v-slot:[`item.charge_id`]="{ item }">
              <div>{{ item.charge_id }}</div>
            </template>
            <template v-slot:[`item.lead_id`]="{ item }">
              <div>{{ item.lead_id }}</div>
            </template>
            <template v-slot:[`item.subscription_id`]="{ item }">
              <div>{{ item.subscription_id }}</div>
            </template>
            <template v-slot:[`item.charge_data.organization_id`]="{ item }">
              <div>{{ item.charge_data.organization_id }}</div>
            </template>
            <template v-slot:[`item.charge_success`]="{ item }">
              <div>
                <v-chip
                  v-if="item.charge_success"
                  color="green"
                  class="white--text"
                  style="
                    width: 90px;
                    display: flex;
                    justify-content: center;
                    max-width: 130px;
                  "
                >
                  {{ $t("afrus_engine.table.success") }}
                </v-chip>
                <v-chip
                  v-else
                  color="red"
                  class="white--text"
                  style="
                    width: 90px;
                    display: flex;
                    justify-content: center;
                    max-width: 130px;
                  "
                >
                  {{ $t("afrus_engine.table.failed") }}
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.cant_be_scheduled`]="{ item }">
              <div>
                <v-icon v-if="item.cant_be_scheduled" color="green"
                  >check</v-icon
                >
                <v-icon v-else color="red">close</v-icon>
              </div>
            </template>
            <template v-slot:[`item.max_attempts_per_month_reached`]="{ item }">
              <div>
                <v-icon v-if="item.max_attempts_per_month_reached" color="green"
                  >check</v-icon
                >
                <v-icon v-else color="red">close</v-icon>
              </div>
            </template>
            <template v-slot:[`item.max_attempts_between_month_reached`]="{ item }">
              <div>
                <v-icon v-if="item.max_attempts_between_month_reached" color="green"
                  >check</v-icon
                >
                <v-icon v-else color="red">close</v-icon>
              </div>
            </template>
            <template v-slot:[`item.charge_rescheduled`]="{ item }">
              <div>
                <v-icon v-if="item.charge_rescheduled" color="green"
                  >check</v-icon
                >
                <v-icon v-else color="red">close</v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <LogDetails />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import LogDetails from "./LogDetails.vue";

export default {
  name: "Logs",
  layout: "Dashboard",
  components: {
    LogDetails,
  },
  data() {
    return {
      filtered: null,
      loading: false,
      items: [],
      total: 0,
      search: "",
      pagination: {
        sortDesc: [true],
        itemsPerPage: 10,
        page: 1,
      },
      headers: [
        {
          text: this.$t("afrus_engine.table.gateway"),
          align: "start",
          sortable: false,
          value: "gateway",
          class: 'text-no-wrap blue--text text--darken-4',
          width: "10%",
        },
        {
          text: this.$t("afrus_engine.table.charge_id"),
          value: "charge_id",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.lead_id"),
          value: "lead_id",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.subscription_id"),
          value: "subscription_id",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.organization_id"),
          value: "charge_data.organization_id",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.charge_success"),
          value: "charge_success",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.cant_be_scheduled"),
          value: "cant_be_scheduled",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.max_attempts_per_month_reached"),
          value: "max_attempts_per_month_reached",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.max_attempts_between_month_reached"),
          value: "max_attempts_between_month_reached",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t("afrus_engine.table.charge_rescheduled"),
          value: "charge_rescheduled",
          width: "10%",
          class: 'text-no-wrap blue--text text--darken-4',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      logs: "afrusEngine/logs",
      totalLogs: "afrusEngine/totalAmount"
    }),
    ...mapState({
      languages: ({ auth: { locales } }) => locales,
    }),
  },
  async created() {
    this.readLogs();
    this.readTotalAmount();
  },
  methods: {
    ...mapMutations({
      filterBySection: "afrusEngine/filterBySection",
      setIsOpenLogDetails: "afrusEngine/setIsOpenLogDetails",
      setLog: "afrusEngine/setLog",
    }),
    ...mapActions({
      getLogs: "afrusEngine/getLogs",
      totalAmount: "afrusEngine/getTotalAmount",
    }),
    async readLogs() {
      await this.getLogs();
    },
    async readTotalAmount() {
      await this.totalAmount();
    },
    openDetails(item) {
      this.setLog(item);
    },
    async getLogsWithFilters() {
      this.loading = true;
      const { page, itemsPerPage } = this.pagination;
      // const { startDate, endDate } = this;
      await this.getLogs({
        page,
        perPage: itemsPerPage,
        search: this.search,
      });
      this.loading = false;
      this.items = this.logs;
      this.total = Number.parseInt(this.totalLogs, 10);
    },
    executeSearch(event) {
      if (event.key === "Enter") {
        this.getLogsWithFilters();
      }
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getLogsWithFilters();
      },
      deep: true,
    },
    logs: {
      handler(value) {
        this.items = value;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.truncateDescription {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.truncateLink {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
